import App from './App.vue'
import router from './router'
import { antComponents } from './antd'
import { CommonComponents } from './use-common-components'
import 'ant-design-vue/dist/antd.css'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import { useDirectives, lazyPlugin, usePermissionPlugin, useModalDirectives } from './directives'
import '/@/styles/index.scss'
import '/@/styles/iconfont.css'
import '/@/assets/font/iconfont.css'
import './utils/rem'
import './permission'
import VueCompareImage from 'vue3-compare-image'
import { syncDocumentTitleFromCacheIfExists } from '/@/utils/page-info'
import { initializeTileRequestOptimizer } from '/@/map-runtime/tile-request-optimizer'
import {
  persistentMars3dMapEnabled,
  platformMapRuntime,
  platformMapSceneIdFromRoutePath
} from '/@/map-runtime/runtime'
// import { hookScript } from './utils/hookAmap'
// hookScript()

initializeTileRequestOptimizer()
router.beforeEach(async (to, from) => {
  if (!persistentMars3dMapEnabled) return true
  const fromScene = platformMapSceneIdFromRoutePath(from.path)
  const toScene = platformMapSceneIdFromRoutePath(to.path)
  if (fromScene && toScene && fromScene !== toScene) {
    await platformMapRuntime.prepareSceneTransition()
  }
  return true
})
const app = createInstance(App)
syncDocumentTitleFromCacheIfExists()
app.use(store, storeKey)
app.use(router)
app.use(CommonComponents)
app.use(antComponents)
app.use(useDirectives)
app.use(useModalDirectives)
app.use(lazyPlugin)
app.use(usePermissionPlugin)
app.use(VueCompareImage)

app.mount('#demo-app')
